import {createAsyncThunk} from '@reduxjs/toolkit';
import CryptoJS from 'crypto-js';
import {fetchStrictly} from '../../../../../../common/shared/api/fetchStrictly';
import {SerializedPagewebError} from '../../../../../../errors/SerializedPagewebError.interface';
import {TalkViewerErrorType} from '../../../../../../errors/TalkViewerErrorType.enum';
import {thunkSerializeError} from '../../../../../../errors/thunkSerializeError.function';
import {ViewerInfo} from '../../../../../../graphql/generated/types';
import {AppState} from '../../../../../../state/store';
import {TALK_VIEWER_STATE_NAME} from '../constant/talkViewerConstant';
import {TalkViewerResponseVo} from '../type/TalkViewerResponse.interface';

export const fetchTalkViewerContentFromCms = createAsyncThunk<
  {response: TalkViewerResponseVo; viewerInfoData: ViewerInfo},
  {storyUid: number; episodeUid: number; accessToken: string; env: string},
  {state: AppState; serializedErrorType: SerializedPagewebError}
>(
  `${TALK_VIEWER_STATE_NAME}/fetchTalkViewerContentFromCms`,
  async ({storyUid, episodeUid, accessToken, env}, {rejectWithValue}) => {
    try {
      const host = env
        ? `https://${env}-api-toctoc-cms.dev.kakaopage.com`
        : 'https://ktn-editor-api.kakaopage.com';
      const contentUrl = `${host}/api/story/${storyUid}/episode/${episodeUid}/preview/encrypt`;
      const previewTalkDataResponse = await (
        await fetchStrictly(contentUrl, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
      ).json();
      // 암호화 키 : AccessToken 뒤에서 16자리
      const secretKey = accessToken.substring(accessToken.length - 16);
      const decryptedData = CryptoJS.AES.decrypt(
        {
          ciphertext: CryptoJS.enc.Hex.parse(
            previewTalkDataResponse.previewProduct
          ),
          iv: '',
          salt: '',
        },
        CryptoJS.enc.Utf8.parse(secretKey),
        {
          mode: CryptoJS.mode.ECB,
        }
      );
      const previewProduct = decryptedData.toString(CryptoJS.enc.Utf8);
      return {
        response: JSON.parse(previewProduct) as TalkViewerResponseVo,
        viewerInfoData: previewTalkDataResponse.viewerInfo,
      };
    } catch (error) {
      console.error(error);
      return rejectWithValue(TalkViewerErrorType.UnknownError);
    }
  },
  {
    serializeError: thunkSerializeError,
  }
);
